<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="姓名" prop="name" style="margin-right:15px">
        <el-input v-model="form.name" placeholder="请输入姓名" />
      </el-form-item>
      <el-form-item label="联系电话" prop="phone" style="margin-right:15px">
        <el-input v-model="form.phone" placeholder="请输入联系电话" />
      </el-form-item>
      <el-form-item label="所属机构" prop="departmentCode" style="margin-right:15px">
        <groupSelect ref="groupSelect" @setGroupCode="setGroupCode" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import groupSelect from "./groupSelect";
export default {
  name: "PartyAdd",
  components: {
    groupSelect
  },
  data() {
    // 校验手机号
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^[1][0-9]{10}$/;
      if (!phoneReg.test(value)) {
        callback(new Error("格式有误"));
      } else {
        callback();
      }
    };
    return {
      form: {
        partyType: "STAFF",
        branchCode: "",
        departmentCode: "",
        teamCode: "",
        name: "",
        phone: "",
        roleCodeList: []
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 50, message: "长度在 2 到 50 个字符", trigger: "blur" }
        ],
        departmentCode: [
          { required: true, message: "请选择所属部门", trigger: "blur" }
        ],
        phone: [{ required: true, validator: validatePhone, trigger: "blur" }]
      }
    };
  },
  created() {},
  methods: {
    setGroupCode(value) {
      this.form.branchCode = value[0];
      this.form.departmentCode = value[1];
      this.form.teamCode = value[2];
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({ url: "/ntocc-basic-api/staffs", method: "post", data })
            .then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherAddMethod");
            })
            .then(() => {
              this.$refs["form"].resetFields();
            });
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "add");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
